/**
 * Add class to the body for adding padding,
 * so the navigation bar doesn't overlap the footer.
 * Needs to go through JS since this is a Page Designer asset.
 */

import { body } from '@utilities/dom-elements';

const HAS_NAVIGATION_BAR_CLASS = 'has--navigation-bar';

class NavigationBar {
  constructor(element) {
    this.element = element;

    body.classList.add(HAS_NAVIGATION_BAR_CLASS);
  }

}

export default NavigationBar;
